import React from 'react';
import { Link } from 'react-router-dom';
import useBreadcrumbs from "use-react-router-breadcrumbs";
import '../Css/breadcrumbs.css';

const Breadcrumb = () => {

  const routes = [
    { path: "/restaurant" },
    { path: "/restaurant/:ou/:qoui" },
    { path: "/restaurant/:ou/:qoui/:date/:heure/:personne" },
    { path: "/restoPage" },
    { path: "/restoPage/:idRestaurant" },
  ];

  const breadcrumbs = useBreadcrumbs(routes);

  const handleAvecCritere = (event, path) => {
    if (path === localStorage.getItem('urlCritereHeure')) {
      event.preventDefault();
    } else if (path === localStorage.getItem('urlCritereDate')) {
      event.preventDefault();
    }
  }


  return (
    <div className="bread">
      {breadcrumbs.map(({ match, breadcrumb }) => (
        <Link key={match.pathname} to={match.pathname} onClick={(e) => handleAvecCritere(e, match.pathname)}>
          {breadcrumb}
        </Link>
      ))}
    </div>
  )
}

export default Breadcrumb;